import {
  UNBOOK_REASONS,
  READABLE_REASONS,
  CONTRACTOR_TYPE,
  CONTRACTOR_TYPE_DE,
  BA_CATEGORY_OPTIONS_TYPE,
} from './shared/constants'

export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_LONG_FORMAT = 'ddd D MMM'
export const DATE_NAME_FORMAT = 'DD MMM YYYY'
export const DATE_CHECKIN_FORMAT = 'DD MMM YYYY, hh:mm A'
export const HOUR_FORMAT = 'HH:mm'
export const DATETIME_PICKER_FORMAT = 'DD/MM/YYYY hh:mm a'
export const DATETIME_MISSION_FORMAT = 'MMM DD, YYYY h:mm A'
export const DAY_TIME_FORMAT = 'ddd Do h:mm a'

export const OBJECT_TYPE_CAMPAIGN = 'campaign'
export const OBJECT_TYPE_CITY_PLAN = 'city-plan'
export const OBJECT_TYPE_ROSTER = 'roster'
export const OBJECT_TYPE_MISSION = 'mission'
export const OBJECT_TYPE_AMBASSADOR = 'ambassador'
export const OBJECT_TYPE_USER = 'user'

export const ACTION_CREATE = 'create'
export const ACTION_EDIT = 'edit'
export const ACTION_VIEW = 'view'

export const MISSION_NO_SHOWN_STATUS = 'NO_SHOWN'

export const UNBOOK_OPTIONS = [
  {
    label: READABLE_REASONS[UNBOOK_REASONS.CLIENT_REQUEST],
    value: UNBOOK_REASONS.CLIENT_REQUEST,
  },
  {
    label: READABLE_REASONS[UNBOOK_REASONS.BA_REQUEST],
    value: UNBOOK_REASONS.BA_REQUEST,
  },
  {
    label: READABLE_REASONS[UNBOOK_REASONS.BAD_WEATHER],
    value: UNBOOK_REASONS.BAD_WEATHER,
  },
  {
    label: READABLE_REASONS[UNBOOK_REASONS.CHEATING_SUSPICIOUS_BEHAVIOUR],
    value: UNBOOK_REASONS.CHEATING_SUSPICIOUS_BEHAVIOUR,
  },
]

export const NOTIFICATION_TYPES = {
  CHAT: 'CHAT',
}

export const USER_PROFILE_LOGS_TYPE = {
  WARNING: 'warning',
  BLOCK: 'block',
  UNBOOK_ALL_MISSIONS: 'unbook_all_missions',
  SHADOW_BAN: 'shadow_ban',
  DISABLED_SHADOW_BAN: 'shadow_ban_disabled',
  APPROVE: 'approve',
  REFUSE_SEND_TO_PRE_ACCESS: 'refuse',
  MISSION_TYPE_ALL: 'mission_type_all',
  MISSION_TYPE_H2H: 'mission_type_h2h',
  MISSION_TYPE_D2D: 'mission_type_d2d',
  WITHHOLD_PAY_TRUE: 'withhold_pay_true',
  WITHHOLD_PAY_FALSE: 'withhold_pay_false',
  FORCE_FIXED_TRUE: 'force_fixed_true',
  FORCE_FIXED_FALSE: 'force_fixed_false',
}

export const PREDEFINED_COLORS = [
  // First 6 surfaced for quick label colouring (per ops request).
  { label: 'Medium Purple', value: '#9370DB' },
  { label: 'Gold', value: '#FFD700' },
  { label: 'Light Pink', value: '#FFB6C1' },
  { label: 'Dark Magenta', value: '#8B008B' },
  { label: 'Dark Orange', value: '#FF8C00' },
  { label: 'Orange Red', value: '#FF4500' },
  // Remaining colours.
  { label: 'Dark Olive Green', value: '#556B2F' },
  { label: 'Dark Salmon', value: '#E9967A' },
  { label: 'Medium Spring Green', value: '#00FA9A' },
  { label: 'Cyan', value: '#00FFFF' },
  { label: 'Dark Slate Gray', value: '#2F4F4F' },
  { label: 'Indian Red', value: '#CD5C5C' },
  { label: 'Purple', value: '#800080' },
  { label: 'Crimson', value: '#DC143C' },
  { label: 'Sienna', value: '#A0522D' },
  { label: 'Olive', value: '#808000' },
  { label: 'Deep Sky Blue', value: '#00BFFF' },
  { label: 'Medium Sea Green', value: '#3CB371' },
  { label: 'Dark Cyan', value: '#008B8B' },
]

export const CONVERSIONS_FETCH_STEP = 5000

export const SOURCE_REGULAR = 'Regular'

export const SOURCE_OPPIZI_ADS = 'Promofy Ads'

export const SOURCE_OPTIONS = [
  {
    label: SOURCE_REGULAR,
    value: false,
  },
  {
    label: SOURCE_OPPIZI_ADS,
    value: true,
  },
]

export const COUNTRY_CODE = {
  AUSTRALIA: 'AU',
  FRANCE: 'FR',
  NETHERLANDS: 'NL',
  NEW_ZEALAND: 'NZ',
  UNITED_KINGDOM: 'UK',
  BELGIUM: 'BE',
  UNITED_STATES: 'US',
  SWITZERLAND: 'CH',
  CANADA: 'CA',
  MEXICO: 'MX',
  GERMANY: 'DE',
  SPAIN: 'ES',
  ITALY: 'IT',
  LUXEMBOURG: 'LU',
  PORTUGAL: 'PT',
  POLAND: 'PL',
  ARGENTINA: 'AR',
  BRAZIL: 'BR',
  IRELAND: 'IE',
  AZEROTH: 'AZ',
}

export const PAYROLL_PROVIDER_TYPES = {
  NL_NMBRS: 'NL_NMBRS',
  NL_TENTOO: 'NL_TENTOO',
}

export const CONTRACTOR_TYPE_TO_LABEL = {
  [CONTRACTOR_TYPE.EMPLOYEE]: 'Employee',
  [CONTRACTOR_TYPE.COMPANY_0_WT]: 'Company w/ no WT - Modelo 130',
  [CONTRACTOR_TYPE.COMPANY_1_WT]: 'Company w/ 1% WT',
  [CONTRACTOR_TYPE.COMPANY_7_WT]: 'Company w/ 7% WT',
  [CONTRACTOR_TYPE.COMPANY_15_WT]: 'Company w/ 15% WT',
  [CONTRACTOR_TYPE.INTERNAL_BA]: 'Internal BA',
}

export const CONTRACTOR_TYPE_DE_TO_LABEL = {
  [CONTRACTOR_TYPE_DE.EMPLOYEE_EXTERNAL]: 'Employee External',
  [CONTRACTOR_TYPE_DE.EMPLOYEE_INTERNAL]: 'Employee Internal',
}

export const CONTRACTOR_TYPE_DE_OPTIONS = [
  {
    label: CONTRACTOR_TYPE_DE_TO_LABEL[CONTRACTOR_TYPE_DE.EMPLOYEE_EXTERNAL],
    value: CONTRACTOR_TYPE_DE.EMPLOYEE_EXTERNAL,
  },
  {
    label: CONTRACTOR_TYPE_DE_TO_LABEL[CONTRACTOR_TYPE_DE.EMPLOYEE_INTERNAL],
    value: CONTRACTOR_TYPE_DE.EMPLOYEE_INTERNAL,
  },
]

export const CONTRACTOR_TYPE_OPTIONS = [
  {
    label: CONTRACTOR_TYPE_TO_LABEL[CONTRACTOR_TYPE.EMPLOYEE],
    value: CONTRACTOR_TYPE.EMPLOYEE,
  },
  {
    label: CONTRACTOR_TYPE_TO_LABEL[CONTRACTOR_TYPE.COMPANY_0_WT],
    value: CONTRACTOR_TYPE.COMPANY_0_WT,
  },
  {
    label: CONTRACTOR_TYPE_TO_LABEL[CONTRACTOR_TYPE.COMPANY_1_WT],
    value: CONTRACTOR_TYPE.COMPANY_1_WT,
  },
  {
    label: CONTRACTOR_TYPE_TO_LABEL[CONTRACTOR_TYPE.COMPANY_7_WT],
    value: CONTRACTOR_TYPE.COMPANY_7_WT,
  },
  {
    label: CONTRACTOR_TYPE_TO_LABEL[CONTRACTOR_TYPE.COMPANY_15_WT],
    value: CONTRACTOR_TYPE.COMPANY_15_WT,
  },
  {
    label: CONTRACTOR_TYPE_TO_LABEL[CONTRACTOR_TYPE.INTERNAL_BA],
    value: CONTRACTOR_TYPE.INTERNAL_BA,
  },
]

export const HARDCODED_PTO_REQUEST_TYPE = 'TIME_OFF'

export const BONUS_THRESHOLD_ERROR =
  'Invalid bonus threshold. Please enter a value between 0% and 100% with up to two decimal places.'

export const BONUS_PER_CONVERSION_ERROR =
  'Invalid bonus per conversion. Please enter a value between 0 and 50 with up to two decimal places.'

export const BA_CATEGORY_TYPE_TO_LABEL = {
  [BA_CATEGORY_OPTIONS_TYPE.STUDENT_LESS_26]: 'Student <26 yo',
  [BA_CATEGORY_OPTIONS_TYPE.NOT_STUDENT_LESS_26]: 'Non-student <26 yo',
  [BA_CATEGORY_OPTIONS_TYPE.NOT_STUDENT_MORE_26]: 'Non-student >26 yo',
}

export const BA_CATEGORY_OPTIONS = [
  {
    label: BA_CATEGORY_TYPE_TO_LABEL[BA_CATEGORY_OPTIONS_TYPE.STUDENT_LESS_26],
    value: BA_CATEGORY_OPTIONS_TYPE.STUDENT_LESS_26,
  },

  {
    label:
      BA_CATEGORY_TYPE_TO_LABEL[BA_CATEGORY_OPTIONS_TYPE.NOT_STUDENT_LESS_26],
    value: BA_CATEGORY_OPTIONS_TYPE.NOT_STUDENT_LESS_26,
  },

  {
    label:
      BA_CATEGORY_TYPE_TO_LABEL[BA_CATEGORY_OPTIONS_TYPE.NOT_STUDENT_MORE_26],
    value: BA_CATEGORY_OPTIONS_TYPE.NOT_STUDENT_MORE_26,
  },
]

export const AUTH_METHOD = {
  OPPIZI: 'OPPIZI',
  SOCIAL: 'SOCIAL',
}

export const US_COUNTRY_ID = 14

export const DE_COUNTRY_ID = 18

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
